import React from 'react'
import {Router} from '@reach/router'
import {GettingStartedOverview} from './getting-started-overview'

const GettingStartedSection = () => {
  return (
    <>
      <Router>
        <GettingStartedOverview default path='overview'/>
      </Router>
    </>
  )
}

export {GettingStartedSection}

export default GettingStartedSection